import './styles.scss';
import HeroComponent from './heroComponent';

import HeroLayout from 'components/Sections/Hero/HeroLayout';
import { useSelector } from 'react-redux';
import {
    selectCurrentLocationIsLoading,
    selectCurrentLocationsHero,
    selectCurrentLocationsTags,
} from 'store/slices/LocationsSlice';
import { generateMetaTags } from 'helpers';
import { Helmet } from 'react-helmet';
import CurrentLocationWorldMap from './Illustration/CarrentWorldMap';

const Hero = () => {
    const hero = useSelector(selectCurrentLocationsHero);
    const isLoading = useSelector(selectCurrentLocationIsLoading);
    const currentLocationTags = useSelector(selectCurrentLocationsTags);
    const metaTags = generateMetaTags(currentLocationTags?.tags, 'meta');
    const metaTitle = generateMetaTags(currentLocationTags?.tags, 'title');

    return (
        <>
            <Helmet
                title={metaTitle ? `${metaTitle}` : hero.small_title}
                meta={metaTags}
                script={[
                    {
                        type: 'application/ld+json',
                        innerHTML: JSON.stringify({
                            '@context': 'http://schema.org',
                            '@type': 'Service',
                            serviceType: hero.small_title,
                            provider: {
                                '@type': 'Organization',
                                name: 'Ping Proxies',
                                url: 'https://www.pingproxies.com',
                            },
                            areaServed: 'Worldwide',
                            description: hero.description,
                        }),
                    },
                ]}
            />
            <HeroLayout image={<CurrentLocationWorldMap isLoading={isLoading} />} isLoading={isLoading}>
                <HeroComponent
                    title={hero.small_title}
                    desc={hero.description}
                    ips={hero.title}
                    button_text={hero.button_text}
                    button_text_link={hero.button_text_link}
                    hasCrumbs={true}
                />
            </HeroLayout>
        </>
    );
};

export default Hero;
